const CLEAR_MODAL_FORM = 'zen/BotIntelligence/AddToGroupModal/CLEAR_MODAL_FORM';
const FETCH_GROUPS = 'zen/BotIntelligence/AddToGroupModal/FETCH_GROUPS';
const FETCH_GROUPS_FAILED = 'zen/BotIntelligence/AddToGroupModal/FETCH_GROUPS_FAILED';
const FETCH_GROUPS_SUCCEEDED = 'zen/BotIntelligence/AddToGroupModal/FETCH_GROUPS_SUCCEEDED';
const SELECTED_ADD_TO_OPTION_CHANGED = 'zen/BotIntelligence/AddToGroupModal/SELECTED_ADD_TO_OPTION_CHANGED';
const SELECTED_CAMPAIGN_CHANGED = 'zen/BotIntelligence/AddToGroupModal/SELECTED_CAMPAIGN_CHANGED';
const SELECTED_GROUP_CHANGED = 'zen/BotIntelligence/AddToGroupModal/SELECTED_GROUP_CHANGED';
const SET_NEW_GROUP_NAME = 'zen/BotIntelligence/AddToGroupModal/SET_NEW_GROUP_NAME';


const initialState = {
  fetchGroupsErrorMessage: null,
  groups: [],
  newGroupName: '',
  addTo: 'existingGroup',
  selectedCampaign: null,
  selectedGroup: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case CLEAR_MODAL_FORM: {
      return initialState;
    }
    case SELECTED_ADD_TO_OPTION_CHANGED: {
      const additionalProps = payload === 'existingGroup'
        ? {newGroupName: ''}
        : {selectedGroup: null};
      return { ...state, addTo: payload, ...additionalProps };
    }
    case SELECTED_CAMPAIGN_CHANGED: {
      return { ...state, selectedCampaign: payload };
    }
    case SELECTED_GROUP_CHANGED: {
      return { ...state, selectedGroup: payload, addTo: 'existingGroup' };
    }
    case SET_NEW_GROUP_NAME: {
      return { ...state, newGroupName: payload };
    }
    case FETCH_GROUPS: {
      return { ...state, fetchGroupsErrorMessage: null, groups: [], selectedGroup: null };
    }
    case FETCH_GROUPS_SUCCEEDED: {
      return { ...state, groups: payload };
    }
    case FETCH_GROUPS_FAILED: {
      return {...state, fetchGroupsErrorMessage: payload};
    }
    default:
      return state;
  }
};

const clearModalForm = () => {
  return { type: CLEAR_MODAL_FORM };
};

const setAddToOption = (payload) => {
  return { type: SELECTED_ADD_TO_OPTION_CHANGED, payload };
};

const setNewGroupNameValue = (payload) => {
  return { type: SET_NEW_GROUP_NAME, payload };
};

const setSelectedCampaign = (payload) => {
  return { type: SELECTED_CAMPAIGN_CHANGED, payload };
};

const setSelectedGroup = (payload) => {
  return { type: SELECTED_GROUP_CHANGED, payload };
};

const fetchGroups = () => {
  return { type: FETCH_GROUPS };
};

const fetchGroupsSucceeded = (payload) => {
  return { type: FETCH_GROUPS_SUCCEEDED, payload };
};

const fetchGroupsFailed = (payload) => {
  return { type: FETCH_GROUPS_FAILED, payload };
};

export default reducer;
export {
  // Actions
  CLEAR_MODAL_FORM,
  FETCH_GROUPS,
  FETCH_GROUPS_FAILED,
  FETCH_GROUPS_SUCCEEDED,
  SELECTED_ADD_TO_OPTION_CHANGED,
  SELECTED_GROUP_CHANGED,
  SELECTED_CAMPAIGN_CHANGED,
  SET_NEW_GROUP_NAME,
  // Action Creators
  clearModalForm,
  fetchGroups,
  fetchGroupsFailed,
  fetchGroupsSucceeded,
  setAddToOption,
  setNewGroupNameValue,
  setSelectedGroup,
  setSelectedCampaign
};
